module.exports = function loadingReducer(state, action) {
	return action.type === "DATA_FETCHING" ? true : false;
};


// WEBPACK FOOTER //
// ./src/reducers/loading.js